<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header title="Course Enrollments" icon="fa-chalkboard-teacher"/>

            <div class="columns mt-6">
                <div class="column is-9-fullhd">
                    <p class="has-text-white" v-if="!enrollments"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading your enrollments...</p>
                    <div v-else>
                        <div v-if="activeEnrollments.length === 0">
                            <p class="has-text-white"><i class="far fa-info-circle fa-fw mr-3"></i>You currently have no active Course Enrollments.<br><i class="far fa-fw mr-3"></i><span class="has-text-weight-bold">Browse the available courses in the Online Course Catalog to get started.</span></p>
                        </div>
                        <div class="columns" v-if="activeEnrollments.length">
                            <div class="column">
                                <enrollment :enrollment="enroll" v-for="enroll in activeEnrollments" class="mb-5"/>
                            </div>
                        </div>
                        <section v-if="completedEnrollments.length !== 0" class="pt-4">
                            <h2 class="mb-1 mt-6 mb-6 has-text-white"><i class="fad fa-check-to-slot fa-fw mr-3"></i>Completed Courses</h2>
                            <enrollment :enrollment="enroll" v-for="enroll in completedEnrollments" class="mb-5"/>
                        </section>

                        <!-- Enrollments retired via the >365-day-expired reactivation path
                             (a new enrollment now carries the course forward) -- effectively
                             dead records at this point, kept visible only as history -->
                        <section v-if="reactivatedEnrollments.length !== 0" class="pt-4">
                            <h2 class="mb-1 mt-6 mb-6 has-text-white"><i class="fad fa-rotate fa-fw mr-3"></i>Reactivated Courses</h2>
                            <enrollment :enrollment="enroll" v-for="enroll in reactivatedEnrollments" class="mb-5"/>
                        </section>

                        <!--                        <b-tabs>-->
                        <!--                            <b-tab-item label="2022">-->

                        <!--                            </b-tab-item>-->

                        <!--                            <b-tab-item label="2021">-->

                        <!--                            </b-tab-item>-->

                        <!--                            <b-tab-item label="2020">-->

                        <!--                            </b-tab-item>-->
                        <!--                        </b-tabs>-->

                    </div>


                </div>
                <div class="column has-text-white has-text-right is-3-fullhd is-hidden-touch is-hidden-desktop-only is-hidden-widescreen-only">
                    <div class="mb-6 ">
                        <router-link :to="{name: 'course-catalog'}">
                            <b-button type="is-light" outlined><i class="fad fa-browsers mr-3"></i>Browse Available Courses</b-button>
                        </router-link>
                    </div>
                </div>
            </div>

        </template>
    </framework>
</template>

<script>
    import Framework from "../../components/framework/Framework";
    import MainHeader from "../../components/framework/MainHeader";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import Enrollment from "../../components/Enrollment";

    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {Enrollment, Framework, SidePanelNav, MainHeader},
        data: function() {
            return {
                showCompleted: false
            };
        },
        computed: {
            ...mapGetters(['enrollments', 'currentUser']),
            activeEnrollments: function() {
                let enrollments = [];
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (!enrollment.completed_at && !enrollment.reactivated_to_enrollment_id) enrollments.push(enrollment);
                }

                enrollments.sort((a, b) => {
                    return new Date(b.started_at) - new Date(a.started_at);
                });

                return enrollments;
            },
            // Retired via the >365-day-expired reactivation path -- a new enrollment
            // now carries the course forward, this one is effectively dead
            reactivatedEnrollments: function() {
                let enrollments = [];
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (enrollment.reactivated_to_enrollment_id) enrollments.push(enrollment);
                }

                enrollments.sort((a, b) => {
                    return new Date(b.reactivated_at) - new Date(a.reactivated_at);
                });

                return enrollments;
            },
            completedEnrollments: function() {
                let enrollments = [];
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (enrollment.completed_at && !enrollment.reactivated_to_enrollment_id) enrollments.push(enrollment);
                }

                enrollments.sort((a, b) => {
                    return new Date(b.completed_at) - new Date(a.completed_at);
                });

                return enrollments;
            }
        },
        methods: {
            ...mapActions(['getEnrollments'])
        },
        mounted() {
            this.getEnrollments();
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }
    }
</style>

<style lang="scss">

</style>
